import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    return (_openBlock(), _createElementBlock("div", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.$emit('click')), ["prevent"])),
        class: "text-muted ms-1 btn-image-link position-relative",
        style: { "height": "24px", "padding": "4px" }
    }, [
        _createVNode(_component_g_icon, {
            width: "16",
            height: "16",
            src: "/assets/icons/pen.svg",
            style: { "vertical-align": "unset", "display": "inline-block" }
        })
    ]));
}
